// =============================================================================
//  Copyright   : 2020 semantics GmbH
//  Date        : $Date: 2020-09-01 22:53:37 +0200 (Tue, 01 Sep 2020) $
//  Author      : Dirk Rothe
//  Worker      : $Author: d.rothe $
//  Revision    : $Rev: 113035 $
//  Purpose     : sagas for fulltext package
// =============================================================================
// ---Third-party imports
import {putResolve, put, takeLatest, select, throttle} from 'redux-saga/effects'

// ---Framework imports
import log from 'uix/logging'
import Api from 'uix/api'

// ---Local imports
import {setCfgOcr} from './actions'

// ---Globals
function* _loadCfgOcr({payload}) {
  let ocr_cfg = yield select(root => root.config.ocr)
  if (ocr_cfg === null) {
    yield putResolve(setCfgOcr('LOADING'))
    let {data, error} = yield Api.get('/api/getOcrConfig')
    if (data) {
      yield put(setCfgOcr(data))
    }
  }
}

export const sagas = {
  //~ loadCfgOcr: takeLatest('LOAD_CFG_OCR', _loadCfgOcr),
  loadCfgOcr: throttle(50, 'LOAD_CFG_OCR', _loadCfgOcr),
}
